export default "__VITE_ASSET__C3O6UnE5__"